import React, { useState } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
const TITLE = "Calculatrice du reste de la division - Calculez le reste de la division entre deux nombres avec précision";
const DESCRIPTION =
  "Calculatrice du reste de la division - Calculez le reste de la division entre deux nombres avec précision pour faire vos calculs mathematiques rapidement et sans erreur. Saisissez vos valeurs et obtenez un resultat immediat avec une methode simple a verifier.";
const KEYWORDS =
  "du reste de la division le reste de la division entre deux nombres avec précision, calculatrice du reste de la division le reste de la division entre deux nombres avec précision, calcul en ligne, mathematiques, pourcentage, formule, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/remainder-calculator/";
const RemainderCalculator = () => {
  const [dividend, setDividend] = useState("");
  const [divisor, setDivisor] = useState("");
  const [remainder, setRemainder] = useState("");
  const [error, setError] = useState("");
  const calculateRemainder = (dividend, divisor) => {
    const quotient = Math.floor(dividend / divisor);
    return dividend - quotient * divisor;
  };
  const handleCalculate = () => {
    try {
      const dividendValue = parseFloat(dividend);
      const divisorValue = parseFloat(divisor);
      if (dividend && divisor) {
        const calculatedRemainder = calculateRemainder(
          dividendValue,
          divisorValue
        );
        setRemainder(calculatedRemainder.toFixed(2));
        setError("");
      } else {
        throw new Error("Veuillez entrer toutes les valeurs pour calculer le reste de la division.");
      }
    } catch (err) {
      setError(err.message);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>Calculatrice du reste de la division</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  La calculatrice du reste de la division est un outil puissant et utile utilisé pour calculer le reste de la division entre deux nombres avec précision et rapidité. Cet outil fournit un résultat précis du reste au moment de diviser un nombre par un autre, ce qui est essentiel dans de nombreuses applications pratiques telles que les mathématiques et la programmation. En mathématiques, le reste de la division est utilisé pour résoudre des problèmes liés aux nombres entiers et simplifier les équations. Dans le domaine de la cryptographie, le calcul du reste de la division est un élément vital pour assurer la sécurité des données et les traiter correctement. En utilisant cette calculatrice, vous pouvez obtenir des résultats rapides et fiables pour améliorer votre efficacité dans divers domaines.
                </p>
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>Calculatrice du reste de la division</h2>
                </div>
                <hr />
                <div className="ltr">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label me-2">
                          Le dividende (premier nombre)
                        </label>
                      </b>
                      <input
                        type="text"
                        placeholder="Entrez le nombre à dividende"
                        value={dividend}
                        onChange={(e) => setDividend(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                      <span className="me-2">Nombre entier</span>
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label me-2">
                          Le diviseur (deuxième nombre)
                        </label>
                      </b>
                      <input
                        type="text"
                        placeholder="Entrez le diviseur"
                        value={divisor}
                        onChange={(e) => setDivisor(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginRight: "10px" }}
                      onClick={handleCalculate}
                    >
                      Calculer
                    </button>
                  </div>
                  <br />
                  {error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-dark">
                      Erreur : {error}
                    </p>
                  )}
                  {remainder !== "" && (
                    <div className="p-3 mb-2 bg-success">
                      <h4 className="text-white">Résultat:</h4>
                      <p className="text-white">Le reste de la division: {remainder}</p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-10">
                <div className="info-sections-container">
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Qu'est-ce que le reste ?</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Le reste est le nombre qui subsiste après une division entière.
                        Par exemple : 17 ÷ 5 donne un quotient de 3, et 5 × 3 = 15,
                        donc le reste est 17 − 15 = 2.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Comment calculer le reste</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Exemple : 81 ÷ 11 — quotient 7, car 7 × 11 = 77,
                        donc le reste est 81 − 77 = 4.
                        Entrez 81 et 11 dans la calculatrice pour obtenir le reste 4.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Utilisation en cryptographie</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        L'opération modulo est fondamentale en cryptographie, notamment
                        dans l'algorithme RSA, pour sécuriser les données numériques.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>

    </div>
  );
};
export default RemainderCalculator;
